import React, { useState } from 'react';

const ZygoSecLanding = () => {
  const [activeTrack, setActiveTrack] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [formStatus, setFormStatus] = useState('idle'); // idle | submitting | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setFormStatus('submitting');

    try {
      const url = new URL('https:///mc.us20.list-manage.com/subscribe/landing-page');
      url.searchParams.set('u', '081962dd4f28d4bdc57da9a42');
      url.searchParams.set('id', '0a99acc906');
      url.searchParams.set('f_id', '00f406e0f0');
      url.searchParams.set('EMAIL', email);
      url.searchParams.set('c', '__mcCallback');

      await new Promise((resolve, reject) => {
        window.__mcCallback = (data) => {
          if (data.result === 'success') {
            resolve(data);
          } else {
            reject(data);
          }
          delete window.__mcCallback;
          script.remove();
        };
        const script = document.createElement('script');
        script.src = url.toString();
        script.onerror = () => {
          reject(new Error('Network error'));
          delete window.__mcCallback;
          script.remove();
        };
        document.body.appendChild(script);
      });

      setFormStatus('success');
    } catch (err) {
      if (err?.msg && err.msg.includes('already subscribed')) {
        setFormStatus('success');
      } else {
        setFormStatus('error');
      }
    }
  };

  const socialMentions = [
    // {
    //     author: 'Watch This Space',
    //     handle: '@wtsdev',
    //     avatarUrl: 'https://pbs.twimg.com/profile_images/1820627484183818240/PJu3uzgG_400x400.jpg',
    //     text: 'Billy is quickly becoming one of my favorite Apple security researchers who publicly share exploit information. Incredible work. This explanation of JIT bugs reminds me a lot of how I understand speculative execution bugs to work.',
    //     date: 'Mar 20',
    //     url: 'https://x.com/wtsdev/status/2035036404938359280',
    // },
    {
      author: 'Matt Johansen',
      handle: '@mattjay',
      avatarUrl: 'https://pbs.twimg.com/profile_images/1994499492645666816/EejFWW2Z_400x400.jpg',
      text: 'Not sure how I never saw Billy\'s videos before. This is a 10/10 iOS exploit breakdown vid. Instant subscribed.',
      date: 'Mar 10',
      url: 'https://x.com/mattjay/status/2031394418314391578'
    },
    {
      author: 'Luke',
      handle: '@datalocaltmp',
      avatarUrl: 'https://pbs.twimg.com/profile_images/1801940671407771648/3P9CL7Lm_400x400.jpg',
      text: 'Honestly such a good resource for folks to learn from - another banger from @bellis1000!',
      date: 'Mar 8',
      url: 'https://x.com/datalocaltmp/status/2030756141366477146'
    },
    {
      author: 'j j',
      handle: '@mistymntncop',
      avatarUrl: 'https://abs.twimg.com/sticky/default_profile_images/default_profile_400x400.png',
      text: 'If you are interested in how binary exploitation works in depth please give Billy\'s videos a watch!',
      date: 'Feb 1',
      url: 'https://x.com/mistymntncop/status/2018111104392855599'
    },
    {
      author: 'Rolf',
      handle: '@Rolf_Govers',
      avatarUrl: 'https://pbs.twimg.com/profile_images/2007444376142622720/YDqVRFLa_400x400.jpg',
      text: 'Very clean and well explained video as always @bellis1000! Would love to see more additions in this Coruna analysis series.',
      date: 'Mar 8',
      url: 'https://x.com/Rolf_Govers/status/2030611707287032044'
    },
    // {
    //   author: 'dillon_franke',
    //   handle: '@dillon_franke',
    //   avatarUrl: 'https://pbs.twimg.com/profile_images/1500566386820599810/w1COxZ1M_400x400.jpg',
    //   text: 'Solid overview of a timeless bug!',
    //   date: 'Oct 26',
    //   url: 'https://x.com/dillon_franke/status/1982532161522848191'
    // }
  ];


  const recentWork = [
    {
      type: 'video',
      title: '\'Reading between the patches: Getting started with iOS security\' presentation',
      description: 'Public talk from Billy Ellis at the \'Objective for the We\' event, hosted in Berlin in 2026',
      thumbnail: 'https://zygosec.com/images/oftw_billy_ellis.jpg',
      url: 'https://www.youtube.com/watch?v=FipYCaouxr8',
      meta: '14K views · May 25th'
    },
    {
      type: 'blog',
      title: 'Uncovering an iOS 26 ImageIO Vulnerability (CVE-2026-28990)',
      description: 'Analysis and PoC for a recent image parsing vulnerability patched in iOS 26.5',
      thumbnail: 'https://zygosec.com/exr_rca_3.png',
      url: 'https://zygosec.com/blog',
      meta: '14K views · May 25th'
    },
    {
      type: 'video',
      title: 'Write your first ARM64 buffer overflow exploit',
      description: 'Learn the fundamentals of hacking by exploiting a simple memory corruption vulnerability',
      thumbnail: 'https://i.ytimg.com/vi/0PEBvtT8UdQ/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLDdhoN0F3tEG6lI7addsM6E4IBLCA',
      url: 'https://www.youtube.com/watch?v=0PEBvtT8UdQ',
      meta: ''
    },
    // {
    //   type: 'video',
    //   title: 'Reverse engineering is easier than you think',
    //   description: 'A hands-on example of iOS system-level reverse engineering that you can follow along with',
    //   thumbnail: 'https://i.ytimg.com/vi/OMfZzLbUm6U/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLAgEYZ6Tg8E7YSWFI59wYbhZ_06xw',
    //   url: 'https://youtu.be/OMfZzLbUm6U?si=paJDn2jMv-cn0Xfb',
    //   meta: 'Blog · 6 min read'
    // },
    
  ];


  const difficultyColor = (d) => {
    const colors = { Easy: '#10b981', Medium: '#f59e0b', Hard: '#ef4444' };
    return colors[d] || '#9ca3af';
  };



  return (
    <div style={styles.container}>
      <style>{`
        @media (max-width: 768px) {
          .hero-grid { grid-template-columns: 1fr !important; gap: 48px !important; padding-top: 100px !important; }
          .hero-title { font-size: 36px !important; }
          .track-grid { grid-template-columns: 1fr !important; }
          .feature-grid { grid-template-columns: 1fr 1fr !important; }
          .stats-grid { grid-template-columns: 1fr 1fr !important; }
          .footer-inner { grid-template-columns: 1fr !important; gap: 48px !important; }
          .footer-links { grid-template-columns: 1fr 1fr !important; }
          .nav-links { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
          .waitlist-form { flex-direction: column !important; }
          .waitlist-form input { width: 80% !important; }
          .waitlist-form button { width: 80% !important; }
          .demo-container { display: none !important; }
          .tweet-masonry { columns: 1 !important; max-width: 420px !important; }
          .work-grid { grid-template-columns: 1fr !important; max-width: 480px !important; margin: 0 auto !important; }
        }
        @media (max-width: 480px) {
          .feature-grid { grid-template-columns: 1fr !important; }
          .stats-grid { grid-template-columns: 1fr !important; }
          .footer-links { grid-template-columns: 1fr !important; }
          .demo-container { transform: scale(0.7) !important; }
          .demo-container { display: none !important; }
        }
        .tweet-stack-card {
          transition: transform 0.4s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.35s ease;
        }
        .tweet-masonry .tweet-stack-card:hover {
          transform: scale(1.03) rotate(0deg) !important;
          box-shadow: 0 20px 48px rgba(0,0,0,0.14) !important;
          z-index: 50 !important;
        }
        .work-card {
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }
        .work-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 16px 40px rgba(0,0,0,0.10);
        }
        .work-card:hover .work-card-img {
          transform: scale(1.05);
        }
        .work-card-img {
          transition: transform 0.4s ease;
        }
      `}</style>

      {/* Dot pattern background */}
      <div style={styles.dotPattern} />

      {/* Navigation */}
      <nav style={styles.nav}>
        <div style={styles.navInner}>
          <div style={styles.logo}>
           <a href="https://zygosec.com">
            <img style={{width: '100px', padding: 0, margin: 0}} class="w-[100px] p-0 m-0" src={require('../images/zygosec-dark.png')} id="logo"/>
           </a>
          </div>
          <div className="nav-links" style={styles.navLinks}>
            <a href="/blog" style={styles.navLink}>Blog</a>
            <a href="/about" style={styles.navLink}>About</a>
          </div>
        </div>
        {menuOpen && (
          <div style={styles.mobileMenu}>
            <a href="/blog" style={styles.mobileNavLink}>Blog</a>
            <a href="/about" style={styles.mobileNavLink}>About</a>
          </div>
        )}
      </nav>

      {/* Hero */}
      <section className="hero-grid" style={styles.hero}>
        <div style={styles.heroContent}>
          <h1 className="hero-title" style={styles.heroTitle}>
            Learn mobile security<br />
            <span style={styles.heroAccent}>by doing.</span>
          </h1>
          <p style={styles.heroDesc}>
            Acquire skills in vulnerability research, reverse engineering & exploit development.
          </p>

          {formStatus === 'success' ? (
            <div style={styles.successMessage}>
              <span style={styles.successIcon}>✓</span>
              <span>You're on the list!</span>
            </div>
          ) : (
            <div className="waitlist-form" style={styles.waitlistForm}>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(e); }}
                required
                style={styles.emailInput}
              />
              <button
                type="button"
                onClick={handleSubmit}
                disabled={formStatus === 'submitting'}
                style={{
                  ...styles.waitlistBtn,
                  opacity: formStatus === 'submitting' ? 0.7 : 1,
                  cursor: formStatus === 'submitting' ? 'not-allowed' : 'pointer'
                }}
              >
                {formStatus === 'submitting' ? 'Joining...' : 'Join the mailing list'}
              </button>
            </div>
          )}
          {formStatus === 'error' && (
            <p style={styles.errorNote}>Something went wrong — please try again.</p>
          )}
          <p style={styles.waitlistNote}>
            By subscribing, I agree to receive communications from ZygoSec.
          </p>
        </div>
        
        {/* Terminal Demo */}
        <div className="demo-container" style={styles.demoContainer}>
          <div style={styles.terminalWindow}>
            <div style={styles.terminalBar}>
              <div style={styles.terminalDots}>
                <span style={{...styles.terminalDot, backgroundColor: '#ff5f57'}} />
                <span style={{...styles.terminalDot, backgroundColor: '#ffbd2e'}} />
                <span style={{...styles.terminalDot, backgroundColor: '#28c840'}} />
              </div>
              <span style={styles.terminalTitle}>bash — exploit</span>
            </div>
            <div style={styles.terminalBody}>
              <pre style={styles.terminalCode}>{`$ ./exploit

[*] Crafting payload...
[*] Buffer size: 32 bytes
[*] Overflow offset: 40 bytes

[+] Sending payload...
[+] Overwriting return address...

[!] Segmentation fault:
        X0: 0x4141414141414141  X1: 0x4141414141414141
        ...
        PC: 0x0041414141414140

zygosec@rop-level-1:~# █`}</pre>
            </div>
          </div>
        </div>
      </section>

    


            {/* ── Recent Work Section ── */}
      <section style={styles.recentWorkSection}>
        <div style={styles.recentWorkInner}>
          <div style={styles.recentWorkHeader}>
            <p style={styles.sectionLabel}>Latest</p>
            <h2 style={styles.sectionTitle}>Recent work</h2>
          </div>

          <div className="work-grid" style={styles.workGrid}>
            {recentWork.map((item, i) => (
              <a
                key={i}
                href={item.url}
                target={item.type === 'video' ? '_blank' : undefined}
                rel={item.type === 'video' ? 'noopener noreferrer' : undefined}
                className="work-card"
                style={styles.workCard}
              >
                <div style={styles.workImageWrap}>
                  <div
                    className="work-card-img"
                    style={{
                      ...styles.workImage,
                      backgroundImage: `url(${item.thumbnail})`
                    }}
                  />
                  <div style={styles.workImageOverlay} />
                  {item.type === 'video' && (
                    <div style={styles.workPlayBtn}>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff">
                        <polygon points="8,5 19,12 8,19" />
                      </svg>
                    </div>
                  )}
                  <span style={styles.workTypeBadge}>
                    {item.type === 'video' ? 'YouTube' : 'Blog'}
                  </span>
                </div>
                <div style={styles.workContent}>
                  <h3 style={styles.workTitle}>{item.title}</h3>
                  <p style={styles.workDesc}>{item.description}</p>
                  {/* <span style={styles.workMeta}>{item.meta}</span> */}
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

 {/* ── Recent Activity Section ── */}
      <section style={styles.activitySection}>
        <div style={styles.activityInner}>
          <div style={styles.sectionHeader}>
            <p style={styles.sectionLabel}>Community</p>
            <h2 style={styles.sectionTitle}>
              What people are saying
              <svg style={{display: 'inline-block', marginLeft: '12px', verticalAlign: 'middle', opacity: 0.15}} width="32" height="32" viewBox="0 0 24 24" fill="#111827">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </h2>
          </div>
          {/* Scattered Tweet Cards */}
          <div className="tweet-masonry" style={styles.tweetMasonry}>
            {socialMentions.map((mention, i) => {
              const rotations = [-1.8, 1.2, -0.7, 1.6, -1.1];
              return (
                <a
                  key={i}
                  href={mention.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tweet-stack-card"
                  style={{
                    ...styles.tweetCard,
                    transform: `rotate(${rotations[i % rotations.length]}deg)`,
                    textDecoration: 'none',
                    color: 'inherit',
                    display: 'block'
                  }}
                >
                  <div style={styles.tweetTop}>
                  <div style={{
                    ...styles.tweetAvatar,
                    backgroundImage: `url(${mention.avatarUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }} />
                   
                    <div style={styles.tweetAuthorBlock}>
                      <span style={styles.tweetAuthorName}>{mention.author}</span>
                      <span style={styles.tweetHandle}>{mention.handle}</span>
                    </div>
                    <svg style={{marginLeft: 'auto', flexShrink: 0, opacity: 0.15}} width="20" height="20" viewBox="0 0 24 24" fill="#111827">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                  </div>
                  <p style={styles.tweetText}>{mention.text}</p>
                  <div style={styles.tweetFooter}>
                    <span style={styles.tweetDate}>{mention.date}</span>
                    <div style={styles.tweetActions}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </section>

    
      {/* Footer */}
      <footer style={styles.footer}>
        <div className="footer-inner" style={styles.footerInner}>
          <div style={styles.footerBrand}>
            <div style={styles.logo}>
              <a>
                <img style={{width: '100px', padding: 0, margin: 0}} class="w-[100px] p-0 m-0" src={require('../images/zygosec-dark.png')} id="logo"/>
              </a>
            </div>
            <p style={styles.footerTagline}>
              Acquire skills in vulnerability research, reverse engineering & exploit development.
            </p>
          </div>
          <div className="footer-links" style={styles.footerLinks}>
            <div style={styles.footerCol}>
              <h4 style={styles.footerHeading}>Resources</h4>
              {/* <a href="https://zygosec.com/blog" style={styles.footerLink}>Blog</a> */}
              <a href="https://www.youtube.com/@BillyEllis" style={styles.footerLink}>YouTube</a>
            </div>
            <div style={styles.footerCol}>
              <h4 style={styles.footerHeading}>Company</h4>
              <a href="/about" style={styles.footerLink}>About</a>
            </div>
          </div>
        </div>
        <div style={styles.footerBottom}>
          <span>© 2026 ZygoSec</span>
          <div style={styles.legalLinks}>
            <a href="/privacy" style={styles.legalLink}>Privacy</a>
            <a href="#" style={styles.legalLink}>Terms</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#ffffff',
    color: '#111827',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    position: 'relative'
  },
  dotPattern: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: 'radial-gradient(#d1d5db 1px, transparent 1px)',
    backgroundSize: '24px 24px',
    opacity: 0.5,
    pointerEvents: 'none',
    zIndex: 0
  },
  nav: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(255,255,255,0.9)',
    backdropFilter: 'blur(12px)',
    borderBottom: '1px solid #f3f4f6',
    zIndex: 100
  },
  navInner: {
    maxWidth: '1120px',
    margin: '0 auto',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  navLinks: {
    display: 'flex',
    gap: '32px'
  },
  navLink: {
    color: '#6b7280',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500,
    transition: 'color 0.2s'
  },
  mobileMenuBtn: {
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    backgroundColor: 'transparent',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    fontSize: '18px',
    cursor: 'pointer',
    color: '#374151'
  },
  mobileMenu: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 24px',
    borderTop: '1px solid #f3f4f6',
    backgroundColor: '#ffffff'
  },
  mobileNavLink: {
    padding: '12px 0',
    color: '#374151',
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: 500,
    borderBottom: '1px solid #f3f4f6'
  },

  // ── Exploit Exercises Section ──
  challengesSection: {
    position: 'relative',
    zIndex: 1,
    borderTop: '1px solid #f3f4f6',
    backgroundColor: '#fafafa',
    padding: '80px 0 96px'
  },
  challengesInner: {
    maxWidth: '1120px',
    margin: '0 auto',
    padding: '0 24px'
  },
  challengesSubtitle: {
    fontSize: '16px',
    color: '#6b7280',
    marginTop: '12px'
  },
  challengesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '20px'
  },
  challengeCard: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column'
  },
  challengeHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px'
  },
  challengeTitle: {
    fontFamily: '"SF Mono", "Fira Code", monospace',
    fontSize: '16px',
    fontWeight: 700,
    color: '#111827'
  },
  difficultyBadge: {
    fontSize: '11px',
    fontWeight: 600,
    padding: '3px 10px',
    borderRadius: '100px',
    border: '1px solid',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  challengeArch: {
    fontSize: '12px',
    color: '#9ca3af',
    fontFamily: '"SF Mono", monospace',
    marginBottom: '12px'
  },
  challengeDesc: {
    fontSize: '14px',
    lineHeight: 1.6,
    color: '#6b7280',
    marginBottom: '16px',
    flex: 1
  },
  conceptTags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    marginBottom: '18px'
  },
  conceptTag: {
    fontSize: '11px',
    fontWeight: 500,
    color: '#374151',
    backgroundColor: '#f3f4f6',
    padding: '4px 10px',
    borderRadius: '100px'
  },
  downloadBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '10px 16px',
    borderRadius: '8px',
    backgroundColor: '#112a31',
    color: '#ffffff',
    fontSize: '13px',
    fontWeight: 600,
    textDecoration: 'none',
    marginTop: 'auto'
  },


  // Hero
  hero: {
    position: 'relative',
    zIndex: 1,
    maxWidth: '1120px',
    margin: '0 auto',
    padding: '140px 24px 100px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '64px',
    alignItems: 'center'
  },
  heroContent: {},
  heroTitle: {
    fontSize: '52px',
    fontWeight: 700,
    lineHeight: 1.1,
    marginBottom: '24px',
    letterSpacing: '-1.5px',
    color: '#111827'
  },
  heroAccent: {
    color: 'rgb(30, 144, 123)'
  },
  heroDesc: {
    fontSize: '18px',
    lineHeight: 1.6,
    color: '#6b7280',
    marginBottom: '32px'
  },
  waitlistForm: {
    display: 'flex',
    gap: '10px',
    alignItems: 'stretch'
  },
  emailInput: {
    maxWidth: '200px',
    flex: 1,
    padding: '14px 16px',
    borderRadius: '8px',
    border: '1px solid #d1d5db',
    fontSize: '15px',
    fontFamily: 'inherit',
    color: '#111827',
    backgroundColor: '#ffffff',
    outline: 'none',
    transition: 'border-color 0.2s',
    minWidth: 0
  },
  waitlistBtn: {
    backgroundColor: '#112a31ff',
    color: '#ffffff',
    border: 'none',
    padding: '14px 24px',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s'
  },
  waitlistNote: {
    fontSize: '13px',
    color: '#9ca3af',
    marginTop: '12px'
  },
  successMessage: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '14px 20px',
    borderRadius: '8px',
    backgroundColor: '#ecfdf5',
    border: '1px solid #a7f3d0',
    color: '#065f46',
    fontSize: '15px',
    fontWeight: 500
  },
  successIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: '#10b981',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 700,
    flexShrink: 0
  },
  errorNote: {
    fontSize: '13px',
    color: '#dc2626',
    marginTop: '8px'
  },

  // Terminal Demo
  demoContainer: {
    position: 'relative',
    height: '420px'
  },
  terminalWindow: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    backgroundColor: '#1a1a2e',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
  },
  terminalBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    backgroundColor: '#16162a',
    borderBottom: '1px solid #2a2a4a'
  },
  terminalDots: {
    display: 'flex',
    gap: '6px'
  },
  terminalDot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%'
  },
  terminalTitle: {
    fontSize: '12px',
    color: '#6b6b8d',
    fontFamily: '"SF Mono", monospace'
  },
  terminalBody: {
    padding: '16px',
    minHeight: '280px'
  },
  terminalCode: {
    margin: 0,
    fontFamily: '"SF Mono", "Fira Code", monospace',
    fontSize: '12px',
    lineHeight: 1.7,
    color: '#a0a0c0',
    whiteSpace: 'pre-wrap'
  },

  // ── Community Tweets Section ──
  activitySection: {
    position: 'relative',
    zIndex: 1,
    borderTop: '1px solid #f3f4f6',
    backgroundColor: '#ffffff',
    padding: '80px 0 96px'
  },
  activityInner: {
    maxWidth: '1120px',
    margin: '0 auto',
    padding: '0 24px'
  },
  sectionHeader: {
    marginBottom: '40px',
    textAlign: 'center'
  },
  sectionLabel: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#112a31',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '8px'
  },
  sectionTitle: {
    fontSize: '36px',
    fontWeight: 700,
    color: '#111827',
    letterSpacing: '-0.5px'
  },

  // Masonry tweet grid
  tweetMasonry: {
    columns: '2',
    columnGap: '20px',
    maxWidth: '800px',
    margin: '0 auto'
  },
  tweetCard: {
    breakInside: 'avoid',
    marginBottom: '20px',
    padding: '22px 24px',
    borderRadius: '16px',
    border: '1px solid #e5e7eb',
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
    position: 'relative',
    cursor: 'pointer'
  },
  tweetTop: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '12px'
  },
  tweetAvatar: {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    flexShrink: 0,
    objectFit: 'cover',
    backgroundColor: '#f3f4f6'
  },
  tweetAuthorBlock: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0
  },
  tweetAuthorName: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#111827',
    lineHeight: 1.2
  },
  tweetHandle: {
    fontSize: '12px',
    color: '#9ca3af'
  },
  tweetText: {
    fontSize: '15px',
    lineHeight: 1.65,
    color: '#374151',
    margin: '0 0 14px 0'
  },
  tweetFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  tweetDate: {
    fontSize: '12px',
    color: '#9ca3af'
  },
  tweetActions: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center'
  },

  // ── Recent Work Section ──
  recentWorkSection: {
    position: 'relative',
    zIndex: 1,
    borderTop: '1px solid #f3f4f6',
    backgroundColor: '#ffffff',
    padding: '80px 0 96px'
  },
  recentWorkInner: {
    maxWidth: '1120px',
    margin: '0 auto',
    padding: '0 24px'
  },
  recentWorkHeader: {
    marginBottom: '40px',
    textAlign: 'center'
  },
  workGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '24px'
  },
  workCard: {
    backgroundColor: '#ffffff',
    borderRadius: '14px',
    overflow: 'hidden',
    border: '1px solid #e5e7eb',
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    flexDirection: 'column'
  },
  workImageWrap: {
    position: 'relative',
    overflow: 'hidden',
    aspectRatio: '16/9',
    backgroundColor: '#1a1a2e'
  },
  workImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  workImageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(to top, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 50%)',
    pointerEvents: 'none'
  },
  workPlayBtn: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: 'rgba(0,0,0,0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(4px)'
  },
  workTypeBadge: {
    position: 'absolute',
    top: '12px',
    left: '12px',
    backgroundColor: 'rgba(255,255,255,0.92)',
    padding: '4px 10px',
    borderRadius: '100px',
    fontSize: '11px',
    fontWeight: 600,
    color: '#374151',
    letterSpacing: '0.2px'
  },
  workContent: {
    padding: '20px 22px 22px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  workTitle: {
    fontSize: '17px',
    fontWeight: 600,
    color: '#111827',
    lineHeight: 1.35,
    marginBottom: '8px'
  },
  workDesc: {
    fontSize: '14px',
    lineHeight: 1.55,
    color: '#6b7280',
    marginBottom: '14px',
    flex: 1
  },
  workMeta: {
    fontSize: '12px',
    color: '#9ca3af',
    fontWeight: 500
  },

  // Footer
  footer: {
    position: 'relative',
    zIndex: 1,
    borderTop: '1px solid #f3f4f6',
    padding: '64px 24px 32px',
    backgroundColor: 'rgba(255,255,255,0.9)'
  },
  footerInner: {
    maxWidth: '1120px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gap: '64px',
    marginBottom: '48px'
  },
  footerBrand: {},
  footerTagline: {
    fontSize: '14px',
    color: '#9ca3af',
    marginTop: '12px'
  },
  footerLinks: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '32px'
  },
  footerCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  footerHeading: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#111827',
    marginBottom: '4px'
  },
  footerLink: {
    fontSize: '14px',
    color: '#6b7280',
    textDecoration: 'none'
  },
  footerBottom: {
    maxWidth: '1120px',
    margin: '0 auto',
    paddingTop: '32px',
    borderTop: '1px solid #f3f4f6',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
    color: '#9ca3af'
  },
  legalLinks: {
    display: 'flex',
    gap: '24px'
  },
  legalLink: {
    color: '#9ca3af',
    textDecoration: 'none'
  }
};

const App = () => {
  return (
    <div>
      <ZygoSecLanding/>
    </div>
  );
};

export default App;
